



import {Component, Prop} from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductIssueState from '@/models/Products/ProductIssues/ProductIssueState';

@Component({ name: 'ProductIssueState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: ProductIssueState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case ProductIssueState.Pending:
                color = "warning--text";
                break;
            case ProductIssueState.Published:
                color = "success--text";
                break;
            case ProductIssueState.Rejected:
                color = "error--text";
                break;
        }
        return color;
    }

}
